import PageTable from "/src/layouts/page/components/PageTable";
import Header from "/src/layouts/page/components/header/Header";
import Home from "/src/features/home/components/Home";
import storage from "/src/utils/storage";
import "./homePage.css";

function HomePage() {

    const {logo, name, bots, datasets} = storage('session').get('company');
    const { username } = storage('local').get('user');

    const head = 
        <>
            <img className="company-logo" srcSet={logo}/>
            <span>{name}</span>
        </>
    return (
        <PageTable>
            <Header title={head}>
            </Header>
            <Home data={{bots, datasets , username }}/>
        </PageTable>
    )
}

export default HomePage